// X-axis zoom for the time-series charts: a slider under the axis, plus wheel
// zoom and drag-to-pan inside the plot. It replaces the toolbox's box zoom,
// which is clunky when all anyone wants is a narrower time window. The Y axes
// follow the visible window wherever the chart lets them auto-scale.
//
// Two things a chart using this has to do:
//
//   * Leave room for the slider: grid.bottom of at least ZOOMED_GRID_BOTTOM, and
//     nothing else (a legend) anchored to the bottom edge.
//   * Build its option under useMemo. echarts-for-react re-applies the option
//     whenever it is not deep-equal to the last one, and functions only compare
//     equal by reference, so an inline tooltip formatter re-applies it on every
//     parent render. With notMerge that snaps the zoom back to the full run
//     under the user's hand.

export const ZOOMED_GRID_BOTTOM = 70;

// On a touch screen a one-finger drag has to scroll the page, or a phone user
// could never scroll past a 400 px chart. Pinch still zooms, and the slider
// still pans.
const isTouch = () =>
    typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(pointer: coarse)').matches;

export const timeAxisZoom = () => [
    {
        type: 'inside',
        xAxisIndex: 0,
        filterMode: 'filter',
        zoomOnMouseWheel: true,
        moveOnMouseWheel: false,
        moveOnMouseMove: !isTouch()
    },
    {
        type: 'slider',
        xAxisIndex: 0,
        filterMode: 'filter',
        height: 20,
        bottom: 8
    }
];

// Save and data view stay; box zoom goes, and restore takes its place as the
// one-click way back to the whole run.
export const timeChartToolbox = {
    feature: {
        restore: {},
        saveAsImage: {},
        dataView: {}
    }
};
